import React, {
  Component,
  useReducer,
  useState,
  useEffect,
  useRef,
  useMemo
} from "react";
import Molstack from "./Molstack";
import { checkCompatibility } from "./CompatCheck";
import MolstackDialog from "./gui/Dialog";
import dialogs from "./dialogs";
import { usePreferences } from "./utils/usePreferences";
import SingleCheckbox from "./gui/Checkbox";
import { FeaturesContext } from "./MolstackContexts";

export default function MolstackApp(props) {
  // Check available features and configure
  const features = useMemo(checkCompatibility, []);
  const [displayPreferences, setDisplayPreferences] = usePreferences(
    "checkCompatibility"
  );

  const [dialogOpen, setDialogOpen] = useState(true);

  //Do not proceed if no WebGL
  if (!features.webgl) {
    const dialog = dialogs.nowebgl;
    return (
      <MolstackDialog
        open={true}
        title={dialog.title}
        message={dialog.getMessage()}
      />
    );
  } else {
    let dialog = null;
    let displaySetting = null;
    let display = true;

    const context = {
      browser: features.browser.name + " " + features.browser.version,
      outdated: features.outdated,
      disabledFeatures: Object.values(features.features).filter(
        feature => !feature.enabled
      )
    };
    if (!features.compatible) {
      dialog = dialogs.unsupported;
      displaySetting = context.outdated
        ? "displayOutdated"
        : "displayUnsupported";
    } else if (context.disabledFeatures.length > 0) {
      dialog = dialogs.disabledFeatures;
      displaySetting = "displayDisabledFeatures";
    }

    if (displaySetting) {
      display = displayPreferences[displaySetting];
    }

    const [checked, setChecked] = useState(!display);

    const checkbox = (
      <SingleCheckbox
        label="Do not display again"
        checked={checked}
        onChange={event => setChecked(event.target.checked)}
        value={displaySetting}
      />
    );

    function closeAndApply() {
      setDialogOpen(false);
      setDisplayPreferences(displaySetting, !checked);
    }

    return (
      <React.Fragment>
        {dialog && display ? (
          <MolstackDialog
            open={dialogOpen}
            onClose={closeAndApply}
            title={dialog.title}
            message={dialog.getMessage(context)}
            additionalAction={checkbox}
          />
        ) : null}
        <FeaturesContext.Provider value={features.features}>
          <Molstack {...props} />
        </FeaturesContext.Provider>
      </React.Fragment>
    );
  }
}
